import { render } from "./TitleTipTap.vue?vue&type=template&id=e44938b0"
import script from "./TitleTipTap.vue?vue&type=script&lang=js"
export * from "./TitleTipTap.vue?vue&type=script&lang=js"

import "./TitleTipTap.vue?vue&type=style&index=0&id=e44938b0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__